import {
  AI_PLATFORM_DUOMI,
  AI_PLATFORM_LINGKEAGI,
  AI_PLATFORM_NOWCODING,
  AI_PLATFORM_PIDOI,
  AI_PLATFORM_SHIYUNAPI,
  normalizeCatalogPlatformId,
} from '../constants/aiPlatforms'

/** 平台下拉展示名（大驼峰；内部 value 仍为后端 platform-key 小写） */
const PLATFORM_DISPLAY_LABEL: Record<string, string> = {
  [AI_PLATFORM_DUOMI]: 'Duomi',
  [AI_PLATFORM_NOWCODING]: 'NowCoding',
  [AI_PLATFORM_SHIYUNAPI]: 'ShiYun',
  [AI_PLATFORM_LINGKEAGI]: 'Lingke',
  [AI_PLATFORM_PIDOI]: 'QIQI',
}

export function platformDisplayLabel(platformId: string): string {
  const normalized = normalizeCatalogPlatformId(platformId)
  if (normalized) {
    return PLATFORM_DISPLAY_LABEL[normalized] ?? platformId
  }
  return platformId
}
